import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PaymentHistoryDetailsRequest, PaymentHistoryItem } from '../../../_core/models/payment-history.model';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { I18nModule, TranslationService } from '@spartacus/core';
import { TableProComponent } from '../../../../../../components/table-pro/table-pro.component';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../../components/alert/alert.component';
import { ReportsService } from '../../../_core/reports.service';
import { Alert, ALERT_TYPE } from '../../../../../../components/alert/alert.model';
import { initialStatus } from '../../../../../../core/models/request-status.model';
import { TableProConfig } from '../../../../../../components/table-pro/core/table-pro.model';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'payment-history-details',
  standalone: true,
  imports: [CommonModule, I18nModule, TableProComponent, LocalLoaderComponent, AlertComponent],
  templateUrl: './payment-history-details.component.html',
  styleUrl: './payment-history-details.component.scss',
})
export class PaymentHistoryDetailsComponent implements OnInit, OnDestroy {
  @Input() data?: {
    item: PaymentHistoryItem;
  };

  request$ = new BehaviorSubject<PaymentHistoryDetailsRequest>(initialStatus);
  subscription = new Subscription();

  tableConfig: TableProConfig = {
    itemsPerPage: 50,
    floattingBottom: true,
    collumnConfig: [
      { id: 'invoiceDate', index: 0, type: 'date' },
      { id: 'appliedAmount', index: 1, type: 'number' },
      { id: 'discountTaken', index: 2, type: 'number' },
      { id: 'dateApplied', index: 3, type: 'date' },
      { id: 'amountDueRemaining', index: 4, type: 'number' },
    ],
  };

  alertDanger: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    private reportsService: ReportsService,
    private modalService: ModalService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.getPaymentDetails();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close() {
    this.modalService.close();
  }

  getPaymentDetails(): void {
    this.subscription.add(
      this.translationService
        .translate('generic.error')
        .pipe(take(1))
        .subscribe(value => {
          this.alertDanger.content = value;
        }),
    );

    if (this.data?.item?.code) {
      this.subscription.add(
        this.reportsService.getPaymentHistoryDetails({ code: this.data.item.code }).subscribe(_report => {
          const report: PaymentHistoryDetailsRequest = {
            ..._report,
          };

          if (report.hasError) {
            this.alertDanger.content = report.message!;
          }

          this.request$.next(report);
        }),
      );
    }
  }
}
